import { HttpErrorResponse } from '@angular/common/http';
import * as Sentry from '@sentry/angular';

export const sentryError = (
  error: HttpErrorResponse | Error | string,
  title: string,
  subtitle?: string,
  additionalContext?: Record<string, unknown>,
): void => {
  console.error(title, subtitle, error);

  // Status 0 means the request was blocked before reaching the server
  // (offline, webview network restrictions, CORS preflight blocked).
  // Treat as expected environmental noise — breadcrumb only, no captureException.
  if (error instanceof HttpErrorResponse && error.status === 0) {
    Sentry.addBreadcrumb({
      category: 'http',
      message: `${title}: request blocked (status 0) — ${error.url ?? subtitle}`,
      level: 'warning',
      data: additionalContext,
    });

    return;
  }

  const errorObj = new Error(String(error));

  errorObj.name = title;
  if (subtitle) errorObj.message = subtitle;

  Sentry.withScope((scope) => {
    if (error instanceof HttpErrorResponse) {
      scope.setContext('http_response', {
        status: error.status,
        statusText: error.statusText,
        url: error.url,
        body: error.error,
      });
    }

    if (additionalContext) scope.setContext('additional_info', additionalContext);

    Sentry.captureException(errorObj);
  });
};
